module.exports = __webpack_public_path__ + "static/media/event_detail.e12f0722.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event_detail.svg
// module id = 314
// module chunks = 1